<template>
  <aside class="share-sidebar">
    <ul class="share-sidebar__list">
      <!-- TODO: Share handlers -->
      <li class="share-sidebar__item share-sidebar__item--facebook">
        <a
          :href="facebookShareUrl"
          target="_blank"
          :title="labels.facebook"
          rel="noreferrer"
        >{{ labels.facebook }}</a>
      </li>
      <li class="share-sidebar__item share-sidebar__item--twitter">
        <a
          :href="twitterShareUrl"
          target="_blank"
          :title="labels.twitter"
          rel="noreferrer"
        >{{ labels.twitter }}</a>
      </li>
      <li class="share-sidebar__item share-sidebar__item--email">
        <a
          :href="emailShareUrl"
          target="_blank"
          :title="labels.email"
          rel="noreferrer"
        >{{ labels.email }}</a>
      </li>
    </ul>
  </aside>
</template>

<script>
export default {
  name: 'ShareSidebar',
  props: {
    labels: {
      type: Object,
      default: () => ({
        facebook: 'facebook',
        twitter: 'twitter',
        email: 'email',
      }),
    },
    emailShareSubject: { type: String, default: 'Check this out!' },
    emailShareBody: { type: String, default: 'Blaah...' },
    twitterShareText: { type: String, default: 'Check this out!' },
  },
  computed: {
    emailShareUrl() {
      return `mailto:?subject=${this.emailShareSubject}&body=${this.emailShareBody} ${window.location.origin}/${encodeURIComponent(window.location.search)}`
    },
    facebookShareUrl() {
      return `https://facebook.com/sharer/sharer.php?u=${window.location.origin}/${encodeURIComponent(window.location.search)}`
    },
    twitterShareUrl() {
      return `https://twitter.com/intent/tweet?text=${this.twitterShareText}&url=${window.location.origin}/${encodeURIComponent(window.location.search)}`
    },
  },
}
</script>
